export default __webpack_public_path__ + "static/media/9.297f8c6c.jpg";